/* import __COLOCATED_TEMPLATE__ from './enable_lightning_web_security_settings.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';

export interface Args {
  isComplete: boolean;
  isLoading: boolean;
  salesforceConfiguration?: SalesforceConfiguration;
  openSessionSettingsPage: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const SalesforceCopilotEnableLightningWebSecuritySettings = templateOnlyComponent<Signature>();
export default SalesforceCopilotEnableLightningWebSecuritySettings;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Copilot::EnableLightningWebSecuritySettings': typeof SalesforceCopilotEnableLightningWebSecuritySettings;
  }
}
